import React, { useState } from "react";
import cx from "classnames";
import { useForm } from "react-hook-form";
import { BlockContent } from "src/components/block-content";
import { ShadowBorder } from "src/components/shadow-border";

import * as styles from "./contact-form.module.css";

const endpoints = {
	contact: "/.netlify/functions/send-email",
};
const axios = require("axios");

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

interface ContactFormProps {
	toEmail: string;
	bilingual: boolean;
	finePrint?: string;
	successMessage: any[];
}

export const ContactForm = ({
	toEmail = "hello@twelvenyc.com",
	bilingual = true,
	finePrint,
	successMessage,
}: ContactFormProps) => {
	const [success, setSuccess] = useState(false);

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const onSubmit = (data: any) => {
		// set to email
		data.toEmail = toEmail;

		handleSuccess();

		// post to lambda function
		axios
			.post(endpoints.contact, JSON.stringify(data))
			.then((response: any) => {
				if (response.status !== 200) {
					handleError();
				} else {
					handleSuccess();
				}
			});
	};

	const handleSuccess = () => {
		// console.log("success!");
		setSuccess(true);
	};

	const handleError = () => {
		console.log("error!");
	};

	return (
		<div className={styles.contactForm}>
			{success ? (
				<BlockContent
					blocks={successMessage}
					className={cx("small-body", styles.successMessage)}
				/>
			) : (
				<form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
					<div className={styles.row}>
						<div className={styles.inputContainer}>
							<label>
								<span className={cx("label", styles.inputLabel)}>
									Name{bilingual && <> / Nom</>}*
								</span>
								<input
									type="text"
									className={cx("small-body", errors.name ? styles.error : "")}
									placeholder={errors.fromEmail && "Required"}
									{...register("name", { required: true })}
								/>
							</label>
						</div>
						<div className={styles.inputContainer}>
							<label>
								<span className={cx("label", styles.inputLabel)}>
									Company Name{bilingual && <> / Nom de la société</>}*
								</span>
								<input
									type="text"
									className={cx(
										"small-body",
										errors.companyName ? styles.error : ""
									)}
									placeholder={errors.fromEmail && "Required"}
									{...register("companyName", { required: true })}
								/>
							</label>
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.inputContainer}>
							<label>
								<span className={cx("label", styles.inputLabel)}>Email*</span>
								<input
									type="email"
									className={cx(
										"small-body",
										errors.fromEmail ? styles.error : ""
									)}
									placeholder={errors.fromEmail && "Required"}
									{...register("fromEmail", {
										required: true,
										pattern: {
											value: EMAIL_REGEX,
											message: "Please enter a valid email address.",
										},
									})}
								/>
							</label>
						</div>
						<div className={styles.inputContainer}>
							<label>
								<span className={cx("label", styles.inputLabel)}>
									Phone Number{bilingual && <> / Téléphone</>}
								</span>
								<input
									className={cx("small-body")}
									{...register("phoneNumber")}
								/>
							</label>
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.inputContainer}>
							<label>
								<span className={cx("label", styles.inputLabel)}>
									Any additional info
									{bilingual && <> / Informations complémentaires</>}
								</span>
								<textarea
									className={cx("small-body")}
									{...register("message")}
								/>
							</label>
						</div>
					</div>
					<div className={styles.row}>
						<button type="submit" className={cx(styles.submitButton)}>
							<ShadowBorder className={styles.submitBorders}>
								<div className={styles.submitButtonInner}>
									<span className="label">Submit</span>
								</div>
							</ShadowBorder>
						</button>
					</div>
					{finePrint && (
						<p className={cx(styles.finePrint, "small-body")}>{finePrint}</p>
					)}
				</form>
			)}
		</div>
	);
};
